import PropTypes from 'prop-types';
import DownloadCounter from './DownloadCounter';
import useSubscriptionStatus from '../../hooks/useSubscriptionStatus';
import { DOWNLOADS_ARE_PERIOD_SCOPED } from '../../utils/contractPeriods';

const SubscriptionDownloadCounter = ({ label = 'Downloads remaining' }) => {
  const { downloads, period, isLoading } = useSubscriptionStatus();
  if (isLoading && !downloads) {
    return (
      <div className="download-counter download-counter-skeleton">
        <div className="download-counter-label">{label}</div>
        <div className="download-counter-value" aria-hidden="true">
          &nbsp;
        </div>
      </div>
    );
  }
  if (!downloads?.limit) return null;
  return (
    <DownloadCounter
      used={downloads.used ?? 0}
      limit={downloads.limit}
      label={label}
      resetsOn={DOWNLOADS_ARE_PERIOD_SCOPED ? (period?.resetsOn ?? null) : null}
    />
  );
};

SubscriptionDownloadCounter.propTypes = {
  label: PropTypes.string
};

export default SubscriptionDownloadCounter;
